// import { useEffect, useState } from "react";
// import { ASSET_PATHS } from "./assets";
// import { AlertOctagon } from "lucide-react";

// export const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [animateExtension, setAnimateExtension] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setAnimateExtension(true);
//       setTimeout(() => setAnimateExtension(false), 1000);
//     }, 3000);
//     return () => clearInterval(interval);
//   }, []);

//   const isExternal = (url) => url.startsWith("http");

//   const menuLinks = {
//     API: "https://docs.captchasonic.com?utm_source=extension&utm_medium=api_link",
//     PRICING: "pricing",
//     CONTACT: "contact",
//     EXTENSION: "extension",
//     FREETRIAL: "https://my.captchasonic.com/?utm_source=extension&utm_medium=free_trial",
//     SIGNUP: "https://my.captchasonic.com/?utm_source=extension&utm_medium=account_link",
//   };

//   const menuItems = ["API", "PRICING", "CONTACT", "EXTENSION"];

//   const PrimaryButton = ({ href, children }) => (
//     <a
//       href={href}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="group relative inline-block text-sm lg:text-base font-bold text-slate-900 px-5 py-2 rounded-md bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-300 ease-in-out hover:shadow-lg hover:shadow-cyan-500/40 transform hover:-translate-y-0.5"
//     >
//       {children}
//     </a>
//   );

//   const SecondaryButton = ({ href, children }) => (
//     <a
//       href={href}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="group relative inline-block"
//     >
//       <div
//         className="relative transition-all duration-300 ease-in-out group-hover:-translate-y-0.5"
//         style={{
//           clipPath:
//             "polygon(0 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%)",
//           padding: "2px",
//           backgroundImage: "linear-gradient(to right, #22d3ee, #4f46e5)",
//         }}
//       >
//         <div
//           className="flex items-center justify-center bg-black/80 backdrop-blur-sm px-4 py-[5px] transition-all duration-300 ease-in-out group-hover:bg-black/60"
//           style={{
//             clipPath:
//               "polygon(0 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%)",
//           }}
//         >
//           <span className="text-sm lg:text-base font-bold text-cyan-200 transition-colors duration-300 group-hover:text-white">
//             {children}
//           </span>
//         </div>
//       </div>
//     </a>
//   );

//   return (
//     <>
//       {/* CSS Animation for Extension Link */}
//       <style>
//         {`
//         @keyframes slideX {
//         0%   { transform: translateX(0); }
//         25%  { transform: translateX(-6px); }
//         50%  { transform: translateX(6px); }
//         75%  { transform: translateX(-4px); }
//         100% { transform: translateX(0); }
//         }
//         .animate-slideX {
//         animation: slideX 0.8s ease-in-out;
//         }
//         `}
//       </style>

//       <nav className="fixed z-50 top-0 left-0 right-0 text-white bg-black/50 backdrop-filter backdrop-blur-lg border-b border-white/10 shadow-lg">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16 md:h-20">
//             {/* Logo */}
//             <a
//               href="/"
//               className="flex-shrink-0 flex items-center space-x-2 transition-opacity duration-300 hover:opacity-90"
//             >
//               <img
//                 src={ASSET_PATHS.sonicImage}
//                 alt="soniclogo"
//                 className="w-12 md:w-14 transform scale-x-[-1]"
//               />
//               <span className="text-3xl md:text-4xl font-pixel font-bold bg-white bg-clip-text text-transparent">
//                 CaptchaSonic
//               </span>
//             </a>

//             {/* Desktop Menu */}
//             <div className="hidden md:flex md:items-center md:space-x-1 lg:space-x-2 font-kodeMono">
//               {menuItems.map((item) => {
//                 const isExtension = item === "EXTENSION";
//                 const animatedClass =
//                   isExtension && animateExtension
//                     ? "animate-slideX text-red-500"
//                     : "";

//                 return (
//                   <a
//                     key={item}
//                     href={menuLinks[item]}
//                     target={isExternal(menuLinks[item]) ? "_blank" : "_self"}
//                     rel={
//                       isExternal(menuLinks[item]) ? "noopener noreferrer" : ""
//                     }
//                     className={`
//                         px-3 py-1 rounded-md text-md lg:text-xl
//                         transition-all duration-300 transform hover:-translate-y-0.5
//                         ${isExtension ? "font-bold" : ""}
//                         ${animatedClass || "text-slate-300 hover:text-white"}
//                     `}
//                   >
//                     {item}
//                   </a>
//                 );
//               })}

//               {/* Action Buttons */}
//               <div className="flex items-center space-x-3 ml-4">
//                 <SecondaryButton href={menuLinks.FREETRIAL}>
//                   Free Trial
//                 </SecondaryButton>
//                 <PrimaryButton href={menuLinks.SIGNUP}>Sign Up</PrimaryButton>
//               </div>
//             </div>

//             {/* Mobile Toggle */}
//             <div className="md:hidden">
//               <button
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//                 className="relative w-8 h-8 flex items-center justify-center focus:outline-none"
//               >
//                 <span className="sr-only">Open main menu</span>
//                 <div className="space-y-1.5">
//                   <span
//                     className={`block w-6 h-0.5 bg-white transition-transform duration-300 ease-in-out ${
//                       isMobileMenuOpen ? "rotate-45 translate-y-2" : ""
//                     }`}
//                   ></span>
//                   <span
//                     className={`block w-6 h-0.5 bg-white transition-opacity duration-300 ease-in-out ${
//                       isMobileMenuOpen ? "opacity-0" : ""
//                     }`}
//                   ></span>
//                   <span
//                     className={`block w-6 h-0.5 bg-white transition-transform duration-300 ease-in-out ${
//                       isMobileMenuOpen ? "-rotate-45 -translate-y-2" : ""
//                     }`}
//                   ></span>
//                 </div>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         <div
//           className={`md:hidden absolute top-full inset-x-0 bg-black/80 backdrop-blur-md transition-all duration-300 ease-in-out ${
//             isMobileMenuOpen
//               ? "opacity-100 translate-y-0"
//               : "opacity-0 -translate-y-4 pointer-events-none"
//           }`}
//         >
//           <div className="p-4 space-y-3 font-kodeMono">
//             {menuItems.map((item) => (
//               <a
//                 key={item}
//                 href={menuLinks[item]}
//                 rel="noopener noreferrer"
//                 className="block px-3 py-3 rounded-md text-base text-slate-200 hover:bg-white/10 transition-colors"
//               >
//                 {item}
//               </a>
//             ))}
//             <div className="border-t border-white/20 my-4"></div>
//             <div className="flex flex-col items-center space-y-4">
//               <a
//                 href={menuLinks.FREETRIAL}
//                 className="block w-full text-center border-2 border-cyan-400 py-2.5 px-4 rounded-md text-base text-cyan-300 hover:bg-cyan-400/20 hover:text-white transition-colors"
//               >
//                 Free Trial
//               </a>
//               <a
//                 href={menuLinks.SIGNUP}
//                 className="block w-full text-center bg-gradient-to-r from-cyan-400 to-blue-500 text-black font-bold py-2.5 px-4 rounded-md text-base"
//               >
//                 Sign Up
//               </a>
              
//             </div>
          
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };





// import { useEffect, useState } from "react";
// import {
//   motion,
//   AnimatePresence,
//   useAnimate,
//   useScroll,
//   useMotionValueEvent, // <-- Import this new hook
// } from "framer-motion";
// import { Menu, X } from "lucide-react";
// import clsx from "clsx";

// import { ASSET_PATHS } from "./assets";

// // --- Data & Utilities ---
// const NAVIGATION_ITEMS = [
//   { label: "API", href: "https://docs.captchasonic.com?utm_source=extension&utm_medium=api_link" },
//   { label: "Pricing", href: "/#pricing" },
//   { label: "Contact", href: "/#contact" },
//   { label: "Extension", href: "/#extension" },
// ];

// const ACTION_LINKS = {
//   FREETRIAL: "https://my.captchasonic.com/?utm_source=extension&utm_medium=free_trial",
//   SIGNUP: "https://my.captchasonic.com/?utm_source=extension&utm_medium=account_link",
// };

// const isExternal = (url) => url.startsWith("http");

// // --- Animation Variants ---
// const mobileMenuVariants = {
//   hidden: {
//     y: "-100%",
//     transition: { type: "spring", stiffness: 300, damping: 30, when: "afterChildren" },
//   },
//   visible: {
//     y: 0,
//     transition: { type: "spring", stiffness: 300, damping: 30, when: "beforeChildren", staggerChildren: 0.05 },
//   },
// };

// const menuItemVariants = {
//   hidden: { y: 20, opacity: 0 },
//   visible: { y: 0, opacity: 1, transition: { type: "spring" } },
// };

// // --- Reusable Motion-Powered Button Components ---
// const PrimaryButton = ({ href, children }) => (
//   <motion.a
//     href={href}
//     target="_blank"
//     rel="noopener noreferrer"
//     className="group relative inline-block text-base font-bold text-slate-900 px-6 py-2.5 rounded-lg bg-gradient-to-r from-lime-400 to-green-500"
//     whileHover={{ 
//       scale: 1.05,
//       boxShadow: "0 0 25px rgba(158, 255, 0, 0.6)",
//       transition: { type: "spring", stiffness: 300, damping: 15 }
//     }}
//     whileTap={{ scale: 0.95 }}
//   >
//     {children}
//   </motion.a>
// );

// const SecondaryButton = ({ href, children }) => (
//   <motion.a
//     href={href}
//     target="_blank"
//     rel="noopener noreferrer"
//     className="group relative inline-block text-base font-bold text-lime-300 px-6 py-2.5 rounded-lg border-2 border-lime-400/80"
//     whileHover={{ 
//       scale: 1.05, 
//       backgroundColor: "rgba(158, 255, 0, 0.1)",
//       color: "#ffffff",
//       borderColor: "#9eff00",
//       transition: { type: "spring", stiffness: 300, damping: 15 }
//     }}
//     whileTap={{ scale: 0.95 }}
//   >
//     {children}
//   </motion.a>
// );


// export const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [scope, animate] = useAnimate();
//   const [isScrolled, setIsScrolled] = useState(false);

//   // Use the built-in Framer Motion hook for scroll tracking.
//   const { scrollY } = useScroll();

//   // useMotionValueEvent is the modern, performant way to react to scroll changes.
//   useMotionValueEvent(scrollY, "change", (latest) => {
//     setIsScrolled(latest > 50);
//   });

//   // Effect for body scroll lock
//   useEffect(() => {
//     document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
//     return () => { document.body.style.overflow = "auto"; };
//   }, [isMobileMenuOpen]);

//   // Framer Motion-powered animation for the "Extension" link
//   useEffect(() => {
//     const animation = async () => {
//       while (true) {
//         await new Promise(resolve => setTimeout(resolve, 4000));
//         if (scope.current) {
//             await animate(scope.current, { rotate: [0, -5, 5, -3, 3, 0] }, { duration: 0.6, ease: "easeInOut" });
//         }
//       }
//     };
//     animation();
//   }, [animate, scope]);

//   return (
//     <>
//       <nav
//         className={clsx(
//           "fixed z-50 top-0 left-0 right-0 text-white transition-all duration-300 ease-in-out",
//           isScrolled
//             ? "bg-slate-950/90 backdrop-blur-lg border-b border-lime-400/10 shadow-xl h-16"
//             : "bg-transparent border-b border-transparent h-20"
//         )}
//       >
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-full">
//           <div className="flex items-center justify-between h-full">
//             {/* Logo */}
//             <motion.a href="/" className="flex-shrink-0 flex items-center space-x-2" whileHover={{ opacity: 0.9 }}>
//               <img src={ASSET_PATHS.sonicImage} alt="CaptchaSonic Logo" className="w-12 md:w-14" />
//               <span className="text-3xl md:text-4xl font-pixel font-bold bg-gradient-to-r from-slate-100 to-lime-300 bg-clip-text text-transparent">
//                 CaptchaSonic
//               </span>
//             </motion.a>

//             {/* Desktop Menu */}
//             <div className="hidden md:flex md:items-center md:space-x-2 lg:space-x-4 font-kodeMono">
//               {NAVIGATION_ITEMS.map((item) => (
//                 <motion.a
//                   key={item.label}
//                   href={item.href}
//                   ref={item.label === "Extension" ? scope : null}
//                   target={isExternal(item.href) ? "_blank" : "_self"}
//                   rel={isExternal(item.href) ? "noopener noreferrer" : ""}
//                   className={clsx(
//                     "px-3 py-1 rounded-md text-lg text-slate-300",
//                     item.label === "Extension" && "font-bold !text-lime-400"
//                   )}
//                   whileHover={{ y: -2, color: "#ffffff" }}
//                 >
//                   {item.label}
//                 </motion.a>
//               ))}
//               <div className="flex items-center space-x-4 ml-6">
//                 <SecondaryButton href={ACTION_LINKS.FREETRIAL}>Free Trial</SecondaryButton>
//                 <PrimaryButton href={ACTION_LINKS.SIGNUP}>Sign Up</PrimaryButton>
//               </div>
//             </div>

//             {/* Mobile Menu Toggle Button */}
//             <div className="md:hidden">
//               <button
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//                 className="relative z-50 p-2 text-lime-300 hover:text-white transition-colors"
//                 aria-controls="mobile-menu"
//                 aria-expanded={isMobileMenuOpen}
//               >
//                 <span className="sr-only">Open main menu</span>
//                 {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
//               </button>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Mobile Menu Overlay */}
//       <AnimatePresence>
//         {isMobileMenuOpen && (
//           <motion.div
//             id="mobile-menu"
//             initial="hidden"
//             animate="visible"
//             exit="hidden"
//             variants={mobileMenuVariants}
//             className="fixed inset-0 z-40 bg-slate-950 md:hidden pt-20"
//           >
//             <div className="container mx-auto p-8 flex flex-col h-full">
//               <div className="flex flex-col items-center space-y-8 mt-8">
//                 {NAVIGATION_ITEMS.map((item) => (
//                   <motion.a
//                     key={item.label}
//                     href={item.href}
//                     variants={menuItemVariants}
//                     target={isExternal(item.href) ? "_blank" : "_self"}
//                     rel={isExternal(item.href) ? "noopener noreferrer" : ""}
//                     className="text-3xl font-kodeMono text-slate-200 hover:text-lime-300"
//                     onClick={() => setIsMobileMenuOpen(false)}
//                   >
//                     {item.label}
//                   </motion.a>
//                 ))}
//               </div>
//               <motion.div
//                 variants={menuItemVariants}
//                 className="w-full border-t border-lime-400/20 mt-auto pt-8 mb-8 flex flex-col items-center space-y-5"
//               >
//                 <a
//                   href={ACTION_LINKS.FREETRIAL}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="w-full max-w-xs text-center text-lg font-bold text-lime-300 py-3 rounded-lg border-2 border-lime-400/80 transition-all duration-300 ease-in-out hover:bg-lime-400/10 hover:text-white"
//                 >
//                   Free Trial
//                 </a>
//                 <a
//                   href={ACTION_LINKS.SIGNUP}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="w-full max-w-xs text-center text-lg font-bold text-slate-900 py-3 rounded-lg bg-gradient-to-r from-lime-400 to-green-500 transition-transform duration-300 hover:scale-105"
//                 >
//                   Sign Up
//                 </a>
//               </motion.div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// };





import { useEffect, useState } from "react";
import {
  motion,
  AnimatePresence,
  useScroll,
  useTransform,
} from "framer-motion";
import { Menu, X } from "lucide-react";
import clsx from "clsx";

// Assume ASSET_PATHS is correctly configured
import { ASSET_PATHS } from "./assets";


// --- Data & Utilities ---
const NAVIGATION_ITEMS = [
  { label: "API", href: "https://docs.captchasonic.com?utm_source=extension&utm_medium=api_link" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Contact", href: "/#contact" },
  { label: "Extension", href: "/#extension" },
];

const ACTION_LINKS = {
  FREETRIAL: "https://my.captchasonic.com/?utm_source=extension&utm_medium=free_trial",
  SIGNUP: "https://my.captchasonic.com/?utm_source=extension&utm_medium=account_link",
};

const isExternal = (url) => url.startsWith("http");


// --- Advanced Animation Variants for Mobile Menu ---
const mobileMenuVariants = {
  hidden: {
    y: "-100%",
    transition: { type: "spring", stiffness: 350, damping: 30, when: "afterChildren" },
  },
  visible: {
    y: 0,
    transition: { type: "spring", stiffness: 350, damping: 30, when: "beforeChildren", staggerChildren: 0.05 },
  },
};

const menuItemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { type: "spring" } },
};


// --- Reusable, Motion-Powered, and Composable Button Components ---
const PrimaryButton = ({ href, children, className }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={clsx(
      "group relative inline-block text-base font-bold text-slate-900 px-6 py-2.5 rounded-lg bg-gradient-to-r from-lime-400 to-green-500",
      className
    )}
    whileHover={{ 
      scale: 1.05,
      boxShadow: "0 0 25px rgba(158, 255, 0, 0.6)",
      transition: { type: "spring", stiffness: 300, damping: 15 }
    }}
    whileTap={{ scale: 0.95 }}
  >
    {children}
  </motion.a>
);

const SecondaryButton = ({ href, children, className }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={clsx(
      "group relative inline-block text-base font-bold text-lime-300 px-6 py-2.5 rounded-lg border-2 border-lime-400/80",
      className
    )}
    whileHover={{ 
      scale: 1.05, 
      backgroundColor: "rgba(158, 255, 0, 0.1)",
      color: "#ffffff",
      borderColor: "#9eff00",
      transition: { type: "spring", stiffness: 300, damping: 15 }
    }}
    whileTap={{ scale: 0.95 }}
  >
    {children}
  </motion.a>
);


export const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // --- Smooth Scroll Animations ---
  // We use `useScroll` to track scroll position and `useTransform` to map it to other values.
  // This creates a much smoother effect than a simple state change.
  const { scrollY } = useScroll();
  const height = useTransform(scrollY, [0, 100], [80, 64]); // Navbar shrinks from 80px to 64px
  const backgroundColor = useTransform(
    scrollY,
    [0, 100],
    ["rgba(13, 13, 26, 0.0)", "rgba(13, 13, 26, 0.9)"] // Fades from transparent to opaque
  );
  const backdropFilter = useTransform(
    scrollY,
    [0, 100],
    ["blur(0px)", "blur(12px)"]
  );

  // Effect for body scroll lock when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [isMobileMenuOpen]);

  return (
    <>
      <motion.nav
        className="fixed z-50 top-0 left-0 right-0 text-white border-b border-lime-400/10 shadow-xl"
        // Apply the animated values directly to the style prop
        style={{ height, backgroundColor, backdropFilter }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-full">
          <div className="flex items-center justify-between h-full">
            {/* Logo */}
            <motion.a 
              href="/" 
              className="flex-shrink-0 flex items-center space-x-2"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              <img src={ASSET_PATHS.sonicImage} alt="CaptchaSonic Logo" className="w-12 md:w-14" />
              <span className="text-3xl md:text-4xl font-pixel font-bold bg-gradient-to-r from-slate-100 to-lime-300 bg-clip-text text-transparent transition-all duration-300 group-hover:from-white group-hover:to-lime-400">
                CaptchaSonic
              </span>
            </motion.a>

            {/* --- Desktop Menu (Visible on lg screens and up) --- */}
            <div className="hidden lg:flex lg:items-center lg:space-x-2 xl:space-x-4 font-kodeMono">
              {NAVIGATION_ITEMS.map((item) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  target={isExternal(item.href) ? "_blank" : "_self"}
                  rel={isExternal(item.href) ? "noopener noreferrer" : ""}
                  className={clsx(
                    "px-3 py-1 rounded-md text-lg text-slate-300",
                    item.label === "Extension" && "font-bold !text-lime-400"
                  )}
                  whileHover={{ y: -2, color: "#ffffff" }}
                  // This is a cleaner, more declarative way to handle the periodic animation
                  animate={item.label === "Extension" ? { rotate: [0, -5, 5, -3, 3, 0] } : {}}
                  transition={item.label === "Extension" ? { duration: 0.6, ease: "easeInOut", repeat: Infinity, repeatDelay: 4 } : {}}
                >
                  {item.label}
                </motion.a>
              ))}
              <div className="flex items-center space-x-4 ml-6">
                <SecondaryButton href={ACTION_LINKS.FREETRIAL}>Free Trial</SecondaryButton>
                <PrimaryButton href={ACTION_LINKS.SIGNUP}>Sign Up</PrimaryButton>
              </div>
            </div>

            {/* --- Mobile & Tablet Menu Toggle (Hidden on lg screens and up) --- */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="relative z-50 p-2 text-lime-300 hover:text-white transition-colors"
                aria-controls="mobile-menu"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>
      </motion.nav>

      {/* --- Mobile Menu Overlay --- */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            id="mobile-menu"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={mobileMenuVariants}
            className="fixed inset-0 z-40 bg-slate-950 lg:hidden"
          >
            <div className="container mx-auto p-8 pt-24 h-full flex flex-col justify-between">
              {/* Top Section: Nav Links */}
              <div className="flex flex-col items-center space-y-8">
                {NAVIGATION_ITEMS.map((item) => (
                  <motion.a
                    key={item.label}
                    href={item.href}
                    variants={menuItemVariants}
                    target={isExternal(item.href) ? "_blank" : "_self"}
                    rel={isExternal(item.href) ? "noopener noreferrer" : ""}
                    className="text-3xl font-kodeMono text-slate-200 hover:text-lime-300"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </motion.a>
                ))}
              </div>
              
              {/* Bottom Section: Action Buttons */}
              <motion.div
                variants={menuItemVariants}
                className="w-full border-t border-lime-400/20 pt-8 flex flex-col items-center space-y-5"
              >
                <SecondaryButton href={ACTION_LINKS.FREETRIAL} className="w-full max-w-xs text-center !text-lg !py-3">
                  Free Trial
                </SecondaryButton>
                <PrimaryButton href={ACTION_LINKS.SIGNUP} className="w-full max-w-xs text-center !text-lg !py-3">
                  Sign Up
                </PrimaryButton>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};